import React from "react";

import { OrderShipmentOfSamplesContextProvider } from "./context/order-shipments-of-samples-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersShipmentOfSamplesPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderShipmentOfSamplesContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderShipmentOfSamplesContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersShipmentOfSamplesPage;
